/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Light Bulb (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgLightBulb = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M39.663 47h4.673M42 33v1m6.364 1.636-.707.707M51 42h-1m-16 0h-1m3.343-5.657-.707-.707m2.828 9.9a5 5 0 1 1 7.072 0l-.548.547A3.37 3.37 0 0 0 44 48.469V49a2 2 0 0 1-4 0v-.531c0-.895-.356-1.754-.988-2.386z"
    />
  </svg>
);
export default SvgLightBulb;
